/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useCallback, useState } from 'react';

export function usePagination(pageSize, totalCount, page, setPage) {
  const [numberOfPages] = useState(Math.ceil(totalCount / pageSize) || 1);
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClickNavigation = useCallback(
    type => () => {
      switch (type) {
        case 'first':
          setPage(0);
          break;
        case 'back':
          setPage(page - 1);
          break;
        case 'next':
          setPage(page + 1);
          break;
        case 'last':
          setPage(numberOfPages - 1);
          break;
        default:
          // eslint-disable-next-line no-console
          console.log('implementation needed');
          break;
      }
    },
    [page, numberOfPages],
  );

  const onChangeElementsDisplayed = useCallback(event => setPage(Number(event.target.value) - 1), []);

  const isDisabled = useCallback(
    (type) => {
      switch (type) {
        case 'first':
        case 'back':
          return page === 0;
        case 'next':
        case 'last':
          return page === numberOfPages - 1;
        default:
          return true;
      }
    },
    [page, numberOfPages],
  );

  return {
    pageSize,
    totalCount,
    page,
    setPage,
    open,
    numberOfPages,
    handleOpen,
    handleClose,
    onClickNavigation,
    onChangeElementsDisplayed,
    isDisabled,
  };
}
